import cookieHandler from '../handlers/cookieHandler'
import type { AuthConfig, IsAuthenticatedOptions } from '../types/types'
import { authApiHandler } from '../services/authApi'
import tokenHandler from '../handlers/tokenHandler'
import { AccessTokenData, IdTokenData } from '../types/tokenTypes'

export default (config: AuthConfig, cookieHeader?: string) => {
  const cookie = cookieHandler(cookieHeader)
  const token = tokenHandler(config)
  const authApi = authApiHandler(config)

  return async (_: IsAuthenticatedOptions = {}): Promise<boolean> => {
    const accessToken = cookie.getAccessToken()
    const validAccessToken = token.getValidToken<AccessTokenData>(accessToken)

    // Server side is read-only: a refresh here would rotate the refresh token without
    // persisting it. The middleware refreshes once per request instead.
    if (typeof window === 'undefined') {
      const validIdToken = token.getValidToken<IdTokenData>(cookie.getIdToken())
      return !!validIdToken && !!validAccessToken
    }

    if (validAccessToken) {
      return true
    }

    if (!accessToken) {
      return false
    }

    // The renewed access token may be httpOnly, so the route's answer counts, not the token.
    return (await authApi.refreshSessionViaServer()).authenticated
  }
}
